import React from "react"
import Post from "../components/post"
import PostCard from "../components/post-card"
import { makeStyles } from "@material-ui/core/styles"
import Grid from "@material-ui/core/Grid"

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
}))

const PostsList = ({ postEdges }) => {
  const classes = useStyles()
  const post = postEdges.map(({ node }) => {
    const {
      id,
      excerpt: autoExcerpt,
      frontmatter: { title, author, coverImage, excerpt, tags },
      fields: { slug, date },
    } = node

    return (
      <>
        {/* <Grid item xs={12} md={6} lg={3}>
          <PostCard
            key={id}
            title={title}
            date={date}
            path={slug}
            author={author}
            coverImage={coverImage}
            tags={tags}
            excerpt={excerpt || autoExcerpt}
          ></PostCard>
        </Grid> */}
        <Post
          key={id}
          title={title}
          date={date}
          path={slug}
          author={author}
          coverImage={coverImage}
          tags={tags}
          excerpt={excerpt || autoExcerpt}
        />
      </>
    )
  })

  return (
    // <div className={classes.root}>
    // <Grid container spacing={2}>
    <>{post}</>
    // </Grid>
    // </div>
  )
}

export default PostsList
